import { cohorts as libCohorts, getNextIntake as libGetNextIntake, Cohort as LibCohort, getCohortStatus, getCurrentSastDate } from '@/lib/data/cohorts';

export interface Cohort extends LibCohort {
  sessionSchedule: string;
}

export const INTAKE_SCHEDULED_ON_REQUEST = 'Next intake: scheduled on request';

export const PRE_PURCHASE_DISCLOSURE =
  'Your intake date will be confirmed within five working days of enrolment. If the confirmed date does not suit you, you may cancel for a full refund.';

export function addWorkingDays(startDate: Date, workingDays: number): Date {
  const result = new Date(startDate.getTime());
  let daysAdded = 0;
  while (daysAdded < workingDays) {
    result.setDate(result.getDate() + 1);
    const dayOfWeek = result.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysAdded++;
    }
  }
  return result;
}

export const cohorts: Cohort[] = libCohorts.map(c => ({
  ...c,
  sessionSchedule: c.schedule
}));

export function getNextIntake(level: 1 | 2, searchParams?: URLSearchParams | string | null): Cohort | null {
  const next = libGetNextIntake(level, searchParams);
  if (!next) return null;
  return {
    ...next,
    sessionSchedule: next.schedule
  };
}

export { getCohortStatus, getCurrentSastDate };
